import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledEmptySalesResultContainer = styled(FlexContainer)`
    margin-top: 16px;
    padding: 16px;
    width: 100%;
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    border-radius: 10px;
`;
